<template>
	<div  class="scrollable only-y" v-loading.fullscreen.lock="fullScreenLoading">
    <div class="customer-top-nav">
			<span class="title" >Import</span>
			<div class="controls">
				<el-button @click="close();">{{$t('buttons.close')}}</el-button>
			</div>
		</div>
    <el-tabs tab-position="top" style="height: 200px;">
      <el-tab-pane label="Contacts/Clients">
        <el-form label-position="top" :model="importModel">
          <el-form-item label="Configuration d'importation">
            <el-select v-model="importModel.integration" placeholder="Select" >
              <el-option
                v-for="item in importModelIntegration"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-select>
          </el-form-item>
          <div v-if="isFreshbooksSelected()">
            <el-form-item label="URL">
              <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="3">
                <el-input v-model="importModel.freshbooks.URL" placeholder="https://freshbooks.com/api/2.1/xml-in"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="Jeton d'authentification">
              <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="3">
                <el-input v-model="importModel.freshbooks.token"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item>
              <el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="3">
                <el-button @click="testFreshbooks();">Tester l'intégration Freshbooks</el-button>
              </el-col>
            </el-form-item>
            <el-collapse v-if="showFreshbooksTrace">
              <el-collapse-item title="Requête" name="1">
                  <el-input type="textarea" :rows="3" v-model="freshbooksTestRequest" :disabled="true"> </el-input>
              </el-collapse-item>
              <el-collapse-item title="Réponse" name="2">
                <el-input type="textarea" :rows="3" v-model="freshbooksTestRequest" :disabled="true"> </el-input>
              </el-collapse-item>
            </el-collapse>
          </div>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="Comptes GL">Comptes GL</el-tab-pane>
      <el-tab-pane label="Transactions">Transactions</el-tab-pane>
    </el-tabs>
	</div>
</template>

<script>
import axios from "axios"

export default {
  data() {
    return {
      fullScreenLoading : true,
      importModel : {
        freshbooks : {

        },
        CSV : {

        },
      },
      importModelIntegration : ['CSV','Freshbooks'],
      showFreshbooksTrace : false,
      freshbooksTestRequest : `<?xml version="1.0" encoding="utf-8"?>\n<request method="system.current"></request>`,
    };
  },components: {

  },
	methods: {
    close(){
			this.$router.go(-1);
		},
    isFreshbooksSelected(){
      return this.importModel.integration=='Freshbooks';
    },
    testFreshbooks(){

      var config = {
        headers: {
          'Access-Control-Allow-Origin': '*'
        },
        auth: {
          username: this.importModel.freshbooks.token
        },
      };

      axios.post(this.importModel.freshbooks.URL,this.freshbooksTestRequest, config)
      .then(response=>{
        // console.log(response);
        this.showFreshbooksTrace=true;
      })

    },
	},
	computed: {

	},
	created(){
    this.fullScreenLoading=false;
	}
}
</script>

<style lang="scss" scoped>
@import '../../../../assets/scss/_variables';

.title {
	font-size : 1.8em;
	font-weight:bold;
	margin-right:20px;
	position:relative;
	float:left;
}
.customer-top-nav{
  height:50px;
}

.controls{
	position:relative;
	float:right;

	button{
		margin-left:20px;
	}
}
</style>
